/**
 * Textarea primitive — shadcn-style, utilitarian (D-03).
 */
import * as React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export function Textarea({ label, error, className = '', id, ...props }: TextareaProps) {
  const textareaId = id ?? label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label
          htmlFor={textareaId}
          className="text-xs font-medium text-text-muted uppercase tracking-wide"
        >
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        {...props}
        className={[
          'w-full bg-bg-input text-text border rounded px-3 py-1.5 text-sm placeholder:text-text-subtle resize-y min-h-[80px]',
          'focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-1 focus:ring-offset-bg',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error ? 'border-danger' : 'border-border',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      />
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}
